import * as __au2ViewDef from './ia-phone-number.html';
import { bindable, BindingMode, customElement, valueConverter } from '@aurelia/runtime-html';
/* tslint:disable:max-line-length */
import {
    CountryInfo,
    getCountryInfoByCountryCode,
    getCountryInfoByDialingCode,
} from './ia-flag-dropdown';
import { GuidGenerator } from './insecure-guid';
import {
    AsYouType,
    CountryCode,
    parsePhoneNumberFromString,
    formatNumber,
} from 'libphonenumber-js';

const defaultPhoneCountry: CountryCode = 'AU';



@valueConverter('formatPhoneNumber')
export class PhoneNumberFormatter {
    public toView(value: string, countryCode = defaultPhoneCountry) {
        if (!value) {
            return value;
        }

        const formatter = createFormatter(countryCode);
        const asYouTypeFormattedNumber = formatter.input(value);

        try {
            const parsedNumber = parsePhoneNumberFromString(
                asYouTypeFormattedNumber,
                countryCode
            );

            const parsedAndFormattedNumber = formatNumber(
                parsedNumber as any,
                'National' as any
            );

            if (
                parsedAndFormattedNumber &&
                parsedNumber.country === defaultPhoneCountry
            ) {
                return parsedAndFormattedNumber;
            } else {
                return asYouTypeFormattedNumber;
            }
        } catch (e) {
            return asYouTypeFormattedNumber;
        }
    }
}

// handler for creating new AsYouTypeFormmatter instances
function createFormatter(country: CountryCode) {
    return new AsYouType(country);
}

@customElement({ ...__au2ViewDef, name: 'ia-phone-number', dependencies: [ ...__au2ViewDef.dependencies, PhoneNumberFormatter ] })
export class IaPhoneNumber {
    @bindable({ mode: BindingMode.twoWay })
    public phoneType: number;

    @bindable({ mode: BindingMode.twoWay })
    public countryInfo: CountryInfo =
        getCountryInfoByCountryCode(defaultPhoneCountry);

    @bindable({ mode: BindingMode.twoWay })
    public phoneNumber: string;

    @bindable public showLabel = true;
    @bindable public hasFocus = false;

    @bindable public readOnly = false;

    protected readonly id: string;

    constructor() {
        const guidGenerator = new GuidGenerator();
        this.id = guidGenerator.generateGuidString();
    }

    // empty bind function to keep changed functions from being called
    // when element is initialized
    /* tslint:disable-next-line:no-empty */
    public bound() {
        if (!this.countryInfo || !this.countryInfo.code) {
            this.countryInfo = getCountryInfoByCountryCode(defaultPhoneCountry);
        }

        if (this.phoneNumber) {
            this.phoneNumberChanged(this.phoneNumber);
        }
    }

    public countryInfoChanged(
        newCountry: CountryInfo,
        oldCountry: CountryInfo | null
    ) {
        if (!newCountry) {
            this.countryInfo =
                oldCountry || getCountryInfoByCountryCode(defaultPhoneCountry);
        } else if (
            oldCountry &&
            oldCountry.code !== newCountry.code &&
            this.phoneNumber &&
            this.phoneNumber.indexOf(`+${oldCountry.dialingCode}`) === 0
        ) {
            const strippedPhoneNumber = this.phoneNumber.replace(
                `+${oldCountry.dialingCode}`,
                ''
            );

            this.phoneNumber = `+${newCountry.dialingCode} ${strippedPhoneNumber}`;
        }
    }

    protected phoneNumberChanged(newValue: string) {
        const formatter = createFormatter(this.countryInfo.code as CountryCode);

        formatter.input(newValue);

        const country = formatter.country;

        // @ts-expect-error This exists but the linter thinks it doesn't
        const dialingCode = formatter.country_phone_code as string;

        if (country) {
            this.countryInfo = getCountryInfoByCountryCode(country);
        } else if (
            dialingCode &&
            dialingCode !== this.countryInfo.dialingCode
        ) {
            this.countryInfo = getCountryInfoByDialingCode(dialingCode);
        }
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = PhoneNumberFormatter;

    // @ts-ignore
    const proto = PhoneNumberFormatter.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }